import { useEffect, useLayoutEffect, useState } from 'react';
import { create } from 'zustand';

export type HeaderState = {
  dark: boolean;
  blur: boolean;
  initial: boolean;
  darken: () => void;
  lighten: () => void;
  setBlur: (blur: boolean) => void;
  reset: () => void;
};
export const useHeader = create<HeaderState>((set, get) => ({
  dark: false,
  blur: false,
  initial: true,
  darken: () => set({ dark: true, initial: false }),
  lighten: () => set({ dark: false, initial: false }),
  setBlur: (blur) => {
    if (get().blur !== blur) {
      set({ blur });
    }
  },
  reset: () => set({ dark: false, initial: true }),
}));

export const useTransition = () => {
  const [transition, setTransition] = useState(false);

  useLayoutEffect(() => {
    setTimeout(() => {
      setTransition(true);
    }, 120);
  }, []);

  return transition;
};

export const useHeaderTheme = () => {
  const { dark, blur, setBlur } = useHeader();

  useEffect(() => {
    const handleScroll = () => {
      const y = Math.ceil(window.pageYOffset || window.scrollY);
      setBlur(y > 0);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [setBlur]);

  return { dark, blur };
};
